import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../BusinessConsulting.css";
import Services from "../Pages/Services";

const BusinessConsulting = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: "0px 0px -50px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-visible");
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll(".animate-on-scroll");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div
        className="container-fluid p-0 banner-section"
        style={{ backgroundImage: "url('img/erp.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-5 text-white text-center">
            <h1 className="pt-5 mt-5 "> Business Consulting</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                   Business Consulting
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="container mb-1 mt-4 py-1">
        <div className="row pt-3 align-items-center">
          <div className="col-md-6 animate-on-scroll fade-in-left">
            <img
              src="img/bc.webp"
              alt="Process Assessment"
              className="img-fluid rounded shadow hover-scale"
            />
          </div>

          <div className="col-md-6 animate-on-scroll fade-in-right">
            <h1 className="fw-bold">Process Assessment</h1>
            <p className="py-1" style={{ fontSize: "18px" }}>
             We at DigiOpen Services provide process assessment consulting by evaluating an organisation's
workflows to identify bottlenecks, inefficiencies, and risks, and by providing actionable
recommendations to improve performance, quality, and maturity. We work with the client
rather than for the client, aiming to build a "helping relationship" that fosters a culture of
continuous improvement. We believe in a collaborative approach that helps organisations
understand and improve their internal processes.</p>

            <p className="py-1" style={{ fontSize: "18px" }}>
Process segmentation based on actual processes is performed in preparation for the next
phase, and the phase of defining target processes and states is completed. Process assessment
is a systematic evaluation of an organisation's processes to identify strengths, weaknesses, and
areas for improvement.
            </p>
          </div>
        </div>
      </div>
      <div className="animate-on-scroll fade-in-up">
        <Services />
      </div>
      <div className="container mb-4 mt-2 py-2">
        <div className="row align-items-center">
          <div className="col-md-6 order-md-1 order-2 animate-on-scroll fade-in-left">
            <h1 className="fw-bold">Defining Technology Roadmap</h1>
            <p className="py-1" style={{ fontSize: "18px" }}>
              DigiOpen Services works with companies to help business leaders define
              technology and system plans that align with and support the
              achievement of their business goals. We provide expert guidance to
              streamline operations, improve efficiency, and ensure seamless
              integration of ERP and business solutions. Our goal is to empower
              organizations with the right tools and strategies to drive growth
              and make informed decisions confidently.
            </p>
          </div>

          <div className="col-md-6 mb-4 mb-md-0 order-md-2 order-1 animate-on-scroll fade-in-right">
            <img
              src="img/services1.jpg"
              alt="Technology Roadmap"
              className="img-fluid rounded shadow hover-scale"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessConsulting;